import React, { useContext, useState } from "react";
import ReactDOM from "react-dom";

import backend from "../../../backend";
import AuthContext from "../../../AuthContext";

const PWD_RX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{12,}$/;

const validatePassword = pwd => {
  if (!pwd) return "Password requerida";
  if (pwd.length < 12) return "Mínimo 12 caracteres";
  if (!/[a-z]/.test(pwd)) return "Debe incluir al menos 1 minúscula";
  if (!/[A-Z]/.test(pwd)) return "Debe incluir al menos 1 mayúscula";
  if (!/\d/.test(pwd))    return "Debe incluir al menos 1 número";
  if (!PWD_RX.test(pwd))  return "Password inválida";
  return null;
};

const MustResetPasswordModal = () => {
  const authContext = useContext(AuthContext);
  const initial = !!authContext?.user?.mustResetPassword;
  const [open, setOpen] = useState(initial);

  const [current, setCurrent] = useState("");
  const [next, setNext]       = useState("");
  const [confirm, setConfirm] = useState("");
  const [err, setErr]         = useState(null);
  const [saving, setSaving]   = useState(false);
  const [done, setDone]       = useState(false);

  if (!open) return null;

  const submit = async () => {
    setErr(null);
    if (!current) {
      setErr("Ingresá tu password actual (la temporal)");
      return;
    }
    const pwdErr = validatePassword(next);
    if (pwdErr) {
      setErr(pwdErr);
      return;
    }
    if (next !== confirm) {
      setErr("Las passwords nuevas no coinciden");
      return;
    }
    setSaving(true);
    try {
      await backend.post("user/me/change-password", {
        currentPassword: current,
        newPassword: next,
      });
      if (authContext?.user) authContext.user.mustResetPassword = false;
      setDone(true);
      setTimeout(() => setOpen(false), 1200);
    } catch (e) {
      setErr(e?.response?.data?.error || e?.response?.data || "No se pudo actualizar la password");
    } finally {
      setSaving(false);
    }
  };

  return ReactDOM.createPortal(
    <div
      className="bini-modal-overlay"
      onKeyDown={e => { if (e.key === "Escape") e.preventDefault(); }}
    >
      <div className="bini-modal" role="dialog" aria-modal="true" style={{ width: 460 }}>
        <div className="bini-modal-title">Cambio de password requerido</div>

        <div style={{ color: "var(--bini-text-secondary)", fontSize: 11, marginBottom: 12, lineHeight: 1.5 }}>
          Tu password actual es temporal. Por seguridad, tenés que elegir una nueva
          antes de continuar usando el sistema.
        </div>

        <div className="bini-field">
          <label>Password actual (la temporal)</label>
          <input
            className="bini-input"
            type="password"
            value={current}
            onChange={e => setCurrent(e.target.value)}
            autoFocus
            disabled={saving || done}
          />
        </div>

        <div className="bini-field">
          <label>Password nueva</label>
          <input
            className="bini-input"
            type="password"
            value={next}
            onChange={e => setNext(e.target.value)}
            disabled={saving || done}
          />
          <div style={{ fontSize: 10, color: "var(--bini-text-muted)", marginTop: 4 }}>
            Mínimo 12 caracteres, con al menos 1 mayúscula, 1 minúscula y 1 número.
          </div>
        </div>

        <div className="bini-field">
          <label>Confirmar password nueva</label>
          <input
            className="bini-input"
            type="password"
            value={confirm}
            onChange={e => setConfirm(e.target.value)}
            disabled={saving || done}
          />
        </div>

        {err && (
          <div className="bini-warning">
            <div className="t">⚠ {String(err)}</div>
          </div>
        )}

        {done && (
          <div className="bini-success-box">
            <div className="t">✓ Password actualizada</div>
            <div className="d">Cerrando…</div>
          </div>
        )}

        <div className="bini-modal-actions" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
          {/* Cerrar sesión — escape para usuario que entró con cuenta equivocada
              (ej. admin necesita seguir trabajando y se logueó por error con
              user que tiene mustResetPassword=true). */}
          <button
            type="button"
            onClick={() => {
              // Limpia todos los tokens (las keys son "dx" y "pk", ver utils.js)
              try { localStorage.clear(); } catch {}
              try { sessionStorage.clear(); } catch {}
              // Reload completo para que App.js re-evalúe auth y mande a /login
              window.location.replace("/");
            }}
            disabled={saving}
            style={{
              background: "transparent",
              color: "var(--bini-text-muted, #888)",
              border: "1px solid var(--bini-border, #444)",
              borderRadius: 5,
              padding: "6px 14px",
              fontSize: 11,
              cursor: "pointer",
            }}
            title="Salir del sistema y volver al login (no cambia tu password)"
          >
            ← Cerrar sesión
          </button>
          <button
            className="bini-btn bini-btn-save"
            onClick={submit}
            disabled={saving || done}
          >
            {saving ? "Guardando…" : "Cambiar password"}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default MustResetPasswordModal;
